namespace ui
{
	export namespace Form
	{
		export interface IFileInputDescriptor extends IBasicInputDescriptor
		{
			multiple?: boolean;
			accept: string[];
			fileChange: ( files: FileList ) => void;
		}

		export class FileInput
			extends Input<IFileInputDescriptor>
		{
			public constructor( descriptor: IFileInputDescriptor )
			{
				super( null, descriptor, 'file', InputValueTypes.FILE );
			}

			public Initialize(): void
			{
				super.Initialize();

				if ( this.Descriptor.accept.length > 0 )
				{
					this.attr( 'accept', this.Descriptor.accept.join( ',' ) );
				}

				if ( this.Descriptor.multiple )
				{
					this.attr( 'multiple', 'multiple' );
				}

				this.on(
					'change',
					() => this.Descriptor.fileChange.call(
						this,
						( this.m_Root[ 0 ] as HTMLInputElement ).files as FileList
					)
				);
			}

			public value( val: string|null ): FileInput
			{
				console.info( 'Security issue! File value can\'t be set!' );
				return this;
			}

			public val(): string | null
			{
				const val = this.m_Root.val() || '';

				return val === '' ? null : val.toString();
			}

		}
	}
}
